// #region imports

// --- Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-dashboard-alert',
  templateUrl: './dashboard-alert.component.html',
  styleUrls: ['./dashboard-alert.component.scss']
})
export class DashboardAlertComponent {

  @Input() showAlert: boolean = false;
  @Input() alertType: string = '';
  @Input() alertText: string = 'Good day!';
  @Input() alertIdentifier: string | null | undefined = null;

  @Output() dismissClick = new EventEmitter();
  @Output() textClick = new EventEmitter<string>();

  onDismiss(): void {
    this.dismissClick.emit();
  }

  onTextClick(): void {
    if (this.alertIdentifier) {
      this.textClick.emit(this.alertIdentifier);
    }
  }
}
